import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';

@Component({
  selector: 'zc-dialog',
  template: `<div class="modal-header" *ngIf="title">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  {{ message }}
</div>
<div class="modal-footer" *ngIf="btnCancelText || btnOkText">
  <button type="button" *ngIf="btnCancelText" class="btn btn-danger" (click)="decline()">{{ btnCancelText }}</button>
  <button type="button" *ngIf="btnOkText" class="btn btn-primary" (click)="accept()">{{ btnOkText }}</button>
</div>`,
  styles: [``]
})
export class ZcDialogComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
